'use client'

import { useEffect, useState } from 'react'
import dynamic from 'next/dynamic'

const Comments = dynamic(() => import('@/components/Comments'), {
  ssr: false,
  loading: () => <p className="py-6 text-center text-sm text-white/45">Loading comments...</p>,
})

export default function OptionalComments({ slug }: { slug: string }) {
  const [enabled, setEnabled] = useState(false)

  useEffect(() => {
    const updateConsent = () => {
      setEnabled(localStorage.getItem('allisports-cookie-consent') === 'all')
    }
    updateConsent()
    window.addEventListener('allisports:consent-change', updateConsent)
    return () => window.removeEventListener('allisports:consent-change', updateConsent)
  }, [])

  if (enabled) return <Comments slug={slug} />

  return (
    <div className="mx-auto max-w-2xl rounded-[20px] border border-white/10 bg-white/3 px-5 py-6 text-center">
      <p className="text-sm leading-6 text-white/55">
        Comments are provided by Disqus and require optional cookies.
      </p>
      <button
        type="button"
        onClick={() => window.dispatchEvent(new Event('allisports:manage-consent'))}
        className="mt-3 text-sm font-bold text-[var(--alli-red)] underline decoration-[var(--alli-red)]/35 underline-offset-4"
      >
        Review cookie choices
      </button>
    </div>
  )
}
